<template>
  <div>
    <Header />
    <section class="section1">
      <div class="bg-img"></div>
      <div class="container container-space-y-l">
        <div class="h1">优卖CRM，为您提供优质的服务</div>
        <div class="desc">
          催付提醒 / 发货提醒 / 自动催评 / 中差评安抚 / 会员管理 / 精准营销 / 数据分析
        </div>
      </div>

      <DecorativeDivider fill="#f6f7fc"
                         points="0 100 100 0 100 100" />
    </section>

    <section class="section2">
      <img class="img1"
           src="@/assets/images/illustration_1.png"
           alt="">
      <div class="wrap">
        <div class="h1-text">这是一款专业的电商CRM</div>
        <div class="h2-text">符合电商特征：高效、准确、低成本</div>
        <div class="h3-text">帮助您更快的了解客户、关怀客户，提高老客户复购，增加营收</div>

        <ul class="pk-card">
          <li class="left">
            <dl>
              <dt>市面上的电商CRM</dt>
              <dd>对操作员要求高</dd>
              <dd>传统CRM复杂流程</dd>
              <dd>与对接平台少且不稳定</dd>
              <dd>产品价格高</dd>
            </dl>
          </li>
          <li class="line"></li>
          <li class="right">
            <dt>优卖CRM</dt>
            <dd>产品操作简单易上手</dd>
            <dd>突出核心功能简化核心功能</dd>
            <dd>稳定的对接全网热门平台</dd>
            <dd>产品价格低</dd>
          </li>
        </ul>
      </div>
    </section>

    <section class="section3 container-space-t-m container-space-b-l">
      <device-browser style="width: 800px; margin-bottom: 80px;"
                      shadow="2">
        <img class="device-browser-img"
             src="@/assets/images/home.jpg">
      </device-browser>
      <device-browser style="width: 800px;"
                      shadow="1">
        <img class="device-browser-img"
             src="@/assets/images/crm_1.jpg">
      </device-browser>
    </section>

    <section class="section4 bg-img-auto"></section>

    <section class="section5">
      <div class="container container-space-y-m">
        <div class="section5-header">
          <h4 class="section5-title">选择我们的理由</h4>
          <p class="section5-desc text-white">网页系统，无需安装与下载，多功能系统管理，易懂秒上手</p>
        </div>
        <ul class="section5-list">
          <li><span class="h1">05</span>s <p>速达体验</p>
          </li>
          <li><span class="h1">137</span>+ <p>国家地区</p>
          </li>
          <li><span class="h1">10</span>w+ <p>用户体验</p>
          </li>
          <li><span class="h1">08</span>w+ <p>通讯账号</p>
          </li>
        </ul>
      </div>
    </section>

    <!-- <section class="section999 bg-img-auto">
      <DecorativeDivider class="position-absolute"
                         fill="#f6f7fc"
                         points="0 0 100 0 100 100" />
    </section> -->

    <BannerRegistration />
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/header'
import Footer from '@/components/footer'
import DecorativeDivider from '@/components/decorative-divider'
import BannerRegistration from '@/components/banner-registration'
import DeviceBrowser from '@/components/device-browser'
export default {
  name: 'Home',
  components: {
    Header,
    Footer,
    DecorativeDivider,
    DeviceBrowser,
    BannerRegistration
  }
}

</script>

<style lang="scss" scoped>
.section1 {
  position: relative;
  width: 100%;
  height: 450px;
  // background: linear-gradient(45deg, #039ee8, #2645db);
  // background: linear-gradient(165deg, #2645db 0%, #039ee8 100%);
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.7)),
    url("~@/assets/images/bg3.jpg");

  color: #fff;

  .desc {
    color: #c5c5c5;
  }

  .bg-img {
    position: absolute;
    width: 100%;
    height: 100%;
    background-image: url("~@/assets/images/contact_bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    top: 0;
  }

  .decorative-divider {
    position: absolute;
    bottom: 0;
  }
}

.section2 {
  position: relative;
  background-color: #f6f7fc;

  .img1 {
    width: 35%;

    margin-top: -80px;
    margin-bottom: -100px;
  }

  .wrap {
    width: 600px;
    margin: 0 auto;

    .h1-text,
    .h2-text,
    .h3-text {
      text-align: center;
    }

    .h1-text,
    .h2-text {
      font-size: 30px;
    }
    .h1-text {
      font-weight: 100;
      margin-bottom: 4px;
    }
    .h2-text {
      font-weight: 900;
      color: #43586a;
      margin-bottom: 4px;
    }
    .h3-text {
      font-size: 20px;
    }

    .pk-card {
      display: flex;
      justify-content: space-around;
      margin-top: 30px;
      padding: 30px 20px;
      background-color: #fff;
      border-radius: 8px;
      box-shadow: 0 25px 20px -20px rgba(0, 0, 0, 0.1),
        0 0 15px rgba(0, 0, 0, 0.3);

      li {
        width: 40%;

        &.line {
          width: 1px;
          margin: 0 10px;
          background-color: #f3f4f5;
        }

        &.left {
          dt {
            color: #f27d01;
          }
        }
        &.right {
          dt {
            color: #2a79de;
          }
        }

        dt {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 18px;
        }

        dd {
          height: 30px;
          line-height: 30px;
          border-bottom: 1px solid #f3f4f5;
        }
      }
    }
  }
}

.section4 {
  width: 100%;
  height: 600px;
  background: linear-gradient(rgba(250, 250, 250, 0.3), rgba(55, 125, 255, 0.1)),
    url("~@/assets/images/bg4.jpg");
  background-size: 100%;
}

.section5 {
  // background: linear-gradient(90deg, #6366f1 0%, #8b5cf6 50%, #d946ef 100%);
  // background: linear-gradient(165deg, #2645db 0%, #039ee8 100%);
  background-color: rgba(55, 125, 255, 0.1);
  // color: #fff;

  .section5-header {
    margin-bottom: 30px;
  }
  .section5-title {
    font-size: 32px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 10px;
  }
  .section5-desc {
    font-size: 16px;
    text-align: center;
  }

  .section5-list {
    display: flex;

    li {
      flex-basis: 0;
      flex-grow: 1;
      max-width: 100%;
      text-align: center;
    }
  }
}

.section999 {
  background: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.8)),
    url("~@/assets/images/bg1.png");
}
.section999::after {
  padding: 18.7%;
}
</style>
